/// Campo de busca com lupa.
///
/// O ícone não é enfeite: numa tela cheia de cartões, uma caixa de texto sozinha
/// não se anuncia como busca. Com a lupa, a pessoa vê o que ela faz antes de ler o
/// texto de dentro — que é o que acontece de relance, com o celular no sol.

export function CampoBusca({
  valor,
  aoMudar,
  placeholder,
  autoFocus,
}: {
  valor: string;
  aoMudar: (v: string) => void;
  placeholder: string;
  autoFocus?: boolean;
}) {
  return (
    <div className="relative">
      <span
        aria-hidden
        className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
      >
        <svg
          viewBox="0 0 24 24"
          className="h-5 w-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <circle cx="11" cy="11" r="7" />
          <path d="M20 20l-3.5-3.5" strokeLinecap="round" />
        </svg>
      </span>
      <input
        value={valor}
        onChange={(e) => aoMudar(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
        className="campo pl-10 pr-10"
        type="search"
        inputMode="search"
        autoFocus={autoFocus}
      />
      {valor && (
        <button
          onClick={() => aoMudar("")}
          aria-label="Limpar busca"
          // O "x" nativo do type=search não aparece no Android; sem este botão,
          // limpar a busca com luva exige apagar caractere por caractere.
          className="absolute right-2 top-1/2 grid h-7 w-7 -translate-y-1/2 place-items-center rounded-full text-slate-400 hover:bg-slate-100"
        >
          <svg
            viewBox="0 0 24 24"
            className="h-4 w-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
          >
            <path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" />
          </svg>
        </button>
      )}
    </div>
  );
}
